const DevicesSmartphone = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.1765 23.0769C19.4526 23.0769 19.6765 22.853 19.6765 22.5769C19.6765 22.3008 19.4526 22.0769 19.1765 22.0769V23.0769ZM12.8235 22.0769C12.5474 22.0769 12.3235 22.3008 12.3235 22.5769C12.3235 22.853 12.5474 23.0769 12.8235 23.0769V22.0769ZM20 6.5V7V6.5ZM12 6.5V6V6.5ZM10 23.5H10.5H10ZM10 8.5H9.5H10ZM20 25.5V25V25.5ZM12 25.5V26V25.5ZM22 23.5H22.5H22ZM22 8.5L21.5 8.5V8.5L22 8.5ZM20 6L12 6V7L20 7V6ZM10.5 23.5L10.5 8.5H9.5L9.5 23.5H10.5ZM20 25H12V26H20V25ZM22.5 23.5L22.5 8.5L21.5 8.5L21.5 23.5H22.5ZM20 26C21.3807 26 22.5 24.8807 22.5 23.5H21.5C21.5 24.3284 20.8284 25 20 25V26ZM20 7C20.8284 7 21.5 7.67157 21.5 8.5L22.5 8.5C22.5 7.11929 21.3807 6 20 6V7ZM12 6C10.6193 6 9.5 7.11929 9.5 8.5H10.5C10.5 7.67157 11.1716 7 12 7V6ZM9.5 23.5C9.5 24.8807 10.6193 26 12 26V25C11.1716 25 10.5 24.3284 10.5 23.5H9.5ZM12.8235 23.0769H19.1765V22.0769H12.8235V23.0769Z"
      fill="currentColor"
    />
  </svg>
);

export default DevicesSmartphone;
